module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("E")])])]), _vm._v("vangelina fell asleep and dreamt she was in Cienfuegos. The soft wind blowing across her face ripe from the sea. The air fragrant with the smell of salt and coconuts. There was a baby crying in the yard…and someone was singing it a lullaby. Her sisters were laughing. She could hear them but she couldn’t see them. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carmen. Costanza")]), _vm._v(". The day turned into night and everything was pitched in darkness. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Papa. Papa")]), _vm._v(". And then she was running. And someone was after her. She could hear their footsteps. And then she was on the beach, riding a horse, bareback, holding on to its chestnut mane. The full moon above casting a soft glow and enough light to see by. Carlos was beside her on Silver. He turned and ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("smiled at her. And then the beach was pitched in darkness. And she was thrown.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When she woke up, she was aware of a rhythmic pounding as though someone was banging a sharp object against the bars.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Anna. Anna. Is that you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She tapped against the wall. The banging stopped and a moment later, she heard a humming noise, frantic, almost like a bee. “I know, Anna. I know. You didn’t mean to. Sometimes there isn’t any other choice. You just did what you had to do. Sometimes there isn’t any other way out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The humming noise got deeper and almost melodic. “I know, Anna. I know.”")])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page17"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a185232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/whiterose_ch05.vue
// module id = 87
// module chunks = 0